import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sbw-grid-demo',
  templateUrl: './grid-demo.component.html'
})
export class GridDemoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
